import React from "react"
export function MedicalInsurance(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M12.667 2c.368 0 .666.298.666.667v2h4c.369 0 .667.298.667.666v12a.667.667 0 01-.667.667H2.667A.667.667 0 012 17.333v-12c0-.368.298-.666.667-.666h4v-2c0-.369.298-.667.666-.667h5.334zM7.28 5.667H3V17h14V5.667l-4.281.001-.026.001-5.36.001-.052-.003zM10.501 8v2.832h2.832v1.002H10.5v2.833H9.5v-2.833H6.665v-1.001l2.832-.001V8H10.5zm1.832-5H7.667v1.667h4.666V3z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__medical-insurance"
        />
      </g>
    </svg>
  )
}
